export default __webpack_public_path__ + "static/media/Mark-6-HUD-Artificial Horizon.6d9548df.jpg";